import {Injectable, Injector} from '@angular/core';
import {BaseService} from '@twpub/core/services/base.service';
import {Observable} from 'rxjs';
import {FontFile} from '@twpub/core/models/font-file';

const uri = '/fonts';

@Injectable({
  providedIn: 'root'
})
export class FontFileService extends BaseService {
  constructor(injector: Injector) {
    super(injector);
  }

  public getFontFile(id: number): Observable<FontFile> {
    return this.http.get<FontFile>(this.url(`${uri}/${id}`));
  }

  public getContentUrl(fileId: number) {
    return this.url(`${uri}/${fileId}/content`);
  }

  public saveFile(file: File): Observable<FontFile> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<FontFile>(this.url(`${uri}`), formData);
  }
}
